import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const RunIssuesPage = lazy(() => import('~/features/catalog-enrichment/pages/run-issues-page'));

/** `group` — the (stage, reason) group that is expanded, so a link opens straight to it. */
const searchSchema = z.object({
  group: z.string().optional().catch(undefined),
});

/** A batch's Issues tab — its failed / still-flagged rows grouped by stage + reason. */
export const Route = createFileRoute(
  '/_authenticated/_tenant/catalog-enrichment/runs/$runId/issues',
)({
  validateSearch: searchSchema,
  component: RouteComponent,
});

function RouteComponent() {
  const { runId } = Route.useParams();
  const { group } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <Suspense fallback={<PageSkeleton />}>
      <RunIssuesPage
        runId={runId}
        openGroup={group ?? null}
        onOpenGroup={(next) => {
          void navigate({ search: (prev) => ({ ...prev, group: next ?? undefined }) });
        }}
      />
    </Suspense>
  );
}
